<template>
  <div class="option">
      <button @click="onSave">
        <font-awesome-icon :icon="['fas', 'save']" class="icon" v-if="!saving"/>
        <span v-if="!saving">Save</span>
        <Loader v-if="saving" :auto="true"/>
      </button>
  </div>
</template>

<script>
import Loader from '@/components/Loader'

export default {
  name: 'SaveButton',
  data() {
    return {
      saving: false
    }
  },
  components: {
    Loader
  },
  methods: {
    onSave() {
      this.saving = true;
      this.$emit('onSave');
    },
    saved() {
      this.saving = false;
    }
  },
  created() {
    this.$parent.$on('saved', this.saved);
  }
}
</script>

<style lang="scss" scoped>
.option {
  width: 7rem;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 1rem;
  @media (max-width: 1150px) {
    width: 3rem;
  }

  a {
    text-decoration: none;
  }

  button {
    width: 100%;
    height: 2.5rem;
    font-size: 1.1rem;
    color: white;
    font-weight: bold;
    border: none;
    outline: none;
    background-color: #e6c17d;
    border-radius: 0.3rem;
    transition: 0.2s;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      margin-left: 0.5rem;
      @media (max-width: 1150px) {
        display: none;
      }
    }

    &:hover {
      cursor: pointer;
      background-color: #cfae71;
    }
  }
}
</style>